import { Parcel } from "../../../../front-office/model/parcel";

export class ParcelStockoutCommand {
    private readonly _parcel: Parcel;
    private readonly _productsList: Map<number, number> = new Map<number, number>();

    constructor(parcel: Parcel, productsList: Map<number, number>) {
        this._parcel = parcel;
        this._productsList = productsList;

        if (this._productsList.size === 0) {
            throw new Error("No product map provided, unable to proceed.");
        }
    }

    get parcel(): Parcel {
        return this._parcel;
    }

    get productsList(): Map<number, number> {
        return this._productsList;
    }
}
